/**
 * QRMaps Design System - Theme Configuration
 *
 * Complete theme object combining all design tokens
 * with component-specific configurations
 */

import { colors } from './tokens/colors';
import { spacing } from './tokens/spacing';
import { typography } from './tokens/typography';
import { shadows } from './tokens/shadows';
import { breakpoints, mediaQueries } from './tokens/breakpoints';
import { zIndex } from './tokens/zIndex';
import { transitions } from './tokens/transitions';

export const theme = {
  // Base tokens
  colors,
  spacing,
  typography,
  shadows,
  breakpoints,
  mediaQueries,
  zIndex,
  transitions,

  // Component-specific configurations
  components: {
    // Sidebar configuration (from MainMap.js getSidebarConfig)
    sidebar: {
      width: {
        mobile: '100%',
        desktop: '400px',
      },
      height: {
        mobile: {
          mapOnly: '35vh',
          tourUser: '45vh',
          mapList: '40vh',
          portDockEdit: '40vh',
          tourList: '50vh',
          tourDetail: '50vh',
          chat: '60vh',
          ship: '50vh',
          flightTracking: '60vh',
          fileShare: '70vh',
        },
        desktop: '100vh',
      },
    },

    // Map marker configuration (from markerStyle function)
    map: {
      markerRadius: {
        small: 8,          // Dot marker without number
        medium: 12,        // Numbered marker
        large: 16,         // Lock marker
        lock: 16,
        mapMarker: 18,     // Map marker (green)
        abMarker: 14.4,    // A/B route markers (20% bigger than lock)
        cluster: {
          base: 16,
          max: 32,
        },
      },
      strokeWidth: {
        normal: 2,
        selected: 4,
        important: 3,
        building: {
          default: 1,
          important: 3,
          castle: 3,
          selected: 6,
        },
      },
    },

    // Button configuration
    button: {
      borderRadius: '50%',
      size: {
        sm: '36px',
        md: '44px',   // Current geolocation button size
        lg: '52px',
      },
      iconSize: {
        sm: '16px',
        md: '20px',   // Current geolocation button icon size
        lg: '24px',
      },
    },

    // Card configuration
    card: {
      borderRadius: '8px',
      padding: spacing.lg,
    },

    // Modal configuration
    modal: {
      borderRadius: '8px',
      padding: spacing.xl,
      maxWidth: {
        sm: '400px',
        md: '600px',
        lg: '800px',
      },
    },
  },

  // Utility functions
  utils: {
    // Helper to get responsive value
    responsive: (mobile, desktop) => ({
      mobile,
      desktop,
    }),

    // Helper to convert px to rem
    pxToRem: (px) => `${px / 16}rem`,

    // Helper to create rgba color
    rgba: (hex, alpha) => {
      const r = parseInt(hex.slice(1, 3), 16);
      const g = parseInt(hex.slice(3, 5), 16);
      const b = parseInt(hex.slice(5, 7), 16);
      return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    },
  },
};

export default theme;